import { z } from 'zod';
import { ProdutoPacoteBarraSchema } from '@/features/produto/types/ProdutoPacoteBarra';
import { TabelaPrecoExcecaoTipoPreco, TabelaPrecoTipoVariacao } from './enum';
import { TabelaPrecoProdutoPartialSchema } from './TabelaPrecoProdutoPartial';

export const TabelaPrecoProdutoExcecaoSchema = z.object({
    tpe_idpk: z.number(),
    tpe_preco: z.number(),
    tpe_tipo_preco: z.enum(TabelaPrecoExcecaoTipoPreco),
});

export type TabelaPrecoProdutoExcecao = z.infer<typeof TabelaPrecoProdutoExcecaoSchema>;

const TabelaPrecoProdutoPacoteBarraSchema = ProdutoPacoteBarraSchema.pick({
    pcb_cod_barra: true,
    pcb_descricao: true,
    pcb_idpk: true,
    pcb_multiplicador: true,
    pcb_produto_unidade_idpk: true,
    pcb_tipo_preco: true,
    pcb_valor: true,
});

export const TabelaPrecoProdutoSchema = z.object({
    preco_calculado: z.number(),
    preco_tabela: z.number(),
    produto: TabelaPrecoProdutoPartialSchema,
    produto_pacote_barra: TabelaPrecoProdutoPacoteBarraSchema.nullable(),
    tabela_preco_excecao: TabelaPrecoProdutoExcecaoSchema.nullable(),
    tap_descricao: z.string(),
    tap_empresa_idpk: z.number(),
    tap_idpk: z.number(),
    tap_percentual: z.number().nullable(),
    tap_tipo_variacao: z.enum(TabelaPrecoTipoVariacao),
});

export type TabelaPrecoProduto = z.infer<typeof TabelaPrecoProdutoSchema>;
